"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionName = void 0;
var InteractionName;
(function (InteractionName) {
    InteractionName["BannerComponentLoad"] = "banner-component-load";
    InteractionName["BannerRender"] = "banner-render";
    InteractionName["FetchBnplMethods"] = "fetch-bnpl-methods";
    InteractionName["FetchBannerSettings"] = "fetch-banner-settings";
})(InteractionName = exports.InteractionName || (exports.InteractionName = {}));
//# sourceMappingURL=InteractionName.js.map